export enum RepCardActions {
    ACCORDION_TOGGLE = 0,
    EXPAND_TABLE_TOGGLE,
    SHOW_MORE_TOGGLE,
}
